interface WeekNavigatorProps {
  label: string;
  onPrev: () => void;
  onNext: () => void;
  canPrev: boolean;
  canNext: boolean;
}

export function WeekNavigator({ label, onPrev, onNext, canPrev, canNext }: WeekNavigatorProps) {
  return (
    <div className="week-nav">
      <button
        type="button"
        className="week-nav-btn"
        onClick={onPrev}
        disabled={!canPrev}
        aria-label="Previous week"
      >
        ‹
      </button>
      <span className="week-nav-label">{label}</span>
      <button
        type="button"
        className="week-nav-btn"
        onClick={onNext}
        disabled={!canNext}
        aria-label="Next week"
      >
        ›
      </button>
    </div>
  );
}
